export const FETCH_BOOKINGS_DATA = "FETCH_BOOKINGS_DATA";
export const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
export const FETCH_BOOKINGS_FAILURE = "FETCH_BOOKINGS_FAILURE";

export const FETCH_BOOKINGS_DETAILS_DATA = "FETCH_BOOKINGS_DETAILS_DATA";
export const FETCH_BOOKINGS_DETAILS_SUCCESS = "FETCH_BOOKINGS_DETAILS_SUCCESS";
export const FETCH_BOOKINGS_DETAILS_FAILURE = "FETCH_BOOKINGS_DETAILS_FAILURE";